import { AxiosResponse } from 'axios';

import * as JSONVideos from '../data/videos.json';

import Video from '../interfaces/video';

import api from './api';
import { getItem } from './localSorage';

export interface FetchOnBoardingResponse {
  id: number;
  drugstores_id: number;
  chave: string;
  valor: string;
  type: string;
  metadata: {
    wasWatched: boolean | null;
  };
}

export const getOnboarding = (): Promise<Video[]> => {
  return api
    .get(`/usuarios-configuracoes/all-onboarding?token=${getItem('token')}`)
    .then((response: AxiosResponse<FetchOnBoardingResponse[]>) => {
      const { data } = response;

      const videos = JSONVideos.dispenser;

      const filteredVideos = videos.map((video) => {
        const filteredVideo = data.filter((v) => video.id === v?.chave && v?.metadata?.wasWatched);

        return {
          wasWatched: filteredVideo.length > 0,
          ...video,
        };
      });

      return filteredVideos;
    });
};
